module.exports = __webpack_public_path__ + "img/line.6163d7a8.svg";